import { render, staticRenderFns } from "./ColorsDialog.vue?vue&type=template&id=018ef9cf&scoped=true&"
import script from "./ColorsDialog.vue?vue&type=script&lang=ts&"
export * from "./ColorsDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ColorsDialog.vue?vue&type=style&index=0&id=018ef9cf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "018ef9cf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VRow,VTextField})
